/*
	----------------------------------------------------------------------------------------------------------------------
	CLEARANCE GRID FILTER
	----------------------------------------------------------------------------------------------------------------------

	Drives sections/clearance-filter-grid.liquid: a single-select category row, a sub-filter row that appears
	only once a category is chosen, and hash-based deep linking from the Shop By Category tiles.

	A NEW ENGINE RATHER THAN A REMAP OF bonesaber-grid-filter.js. The established pattern is to reuse an
	existing engine by mapping new facets onto its existing ones — that's how the batting gloves grid runs on
	the Bonesaber engine. It doesn't fit here: the category layer is a facet that changes which OTHER facets
	exist, which that engine has no concept of, and bolting it on would mean editing a file three live pages
	depend on.

	CATEGORIES ARE DISCOVERED FROM THE DOM, NOT LISTED HERE, as of 2026-09-10. This file used to hold a
	hardcoded map of three hashes to three category keys. When Apparel and Off Season were added as categories
	the links silently did nothing, because adding a category meant editing this file and nobody had reason to
	think that. Categories are section blocks now, and both the category id and its hash are read off the
	rendered buttons — a new category needs no change here.

	CATEGORY IS SINGLE-SELECT, SUB-FILTERS ARE MULTI-SELECT. Picking a category is a mode switch; two at once
	would show a filter row that doesn't apply to half the visible cards. Within a category, checking two sizes
	is an OR, matching the Bonesaber and USA grids.

	SWITCHING CATEGORY CLEARS THE PREVIOUS CATEGORY'S SUB-FILTERS. Leaving them checked means an invisible
	filter narrowing results the shopper can no longer see the controls for.

	NO CATEGORY SELECTED = SHOW EVERYTHING. The clearance page's default state is the full catalog, so the
	category row narrows rather than gates.
*/

(function () {
	'use strict';

	function parseFacets(card) {
		if (card._clearanceFacets) return card._clearanceFacets;

		var raw = card.getAttribute('data-clearance-facets');
		var facets = { category: '', certification: '', lengths: [], sizes: [] };

		if (raw) {
			try {
				var parsed = JSON.parse(raw);
				facets.category = parsed.category || '';
				facets.certification = parsed.certification || '';
				facets.lengths = parsed.lengths || [];
				facets.sizes = parsed.sizes || [];
			} catch (e) {
				// Leave the defaults. A card with unreadable facets stays visible rather than vanishing — an
				// over-inclusive grid is a smaller failure than a product nobody can find.
			}
		}

		card._clearanceFacets = facets;
		return facets;
	}

	function intersects(a, b) {
		if (!a.length || !b.length) return false;
		for (var i = 0; i < a.length; i++) {
			if (b.indexOf(a[i]) !== -1) return true;
		}
		return false;
	}

	function setUp(root) {
		var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-clearance-category]'));
		var subfilterPanels = Array.prototype.slice.call(root.querySelectorAll('[data-clearance-subfilters]'));
		var cards = Array.prototype.slice.call(root.querySelectorAll('[data-clearance-card]'));
		var emptyState = root.querySelector('[data-clearance-empty-state]');

		// hash (without #) -> category id, and back. Built from what actually rendered.
		var hashToCategory = {};
		var categoryToHash = {};

		categoryButtons.forEach(function (button) {
			var hash = button.getAttribute('data-clearance-hash');
			var category = button.getAttribute('data-clearance-category');
			if (!hash) return;

			hash = hash.toLowerCase();
			hashToCategory[hash] = category;
			categoryToHash[category] = hash;
		});

		var activeCategory = '';

		function activeValues(category, facet) {
			var panel = root.querySelector('[data-clearance-subfilters="' + category + '"]');
			if (!panel) return [];

			var inputs = panel.querySelectorAll('[data-clearance-filter="' + facet + '"]:checked');
			return Array.prototype.map.call(inputs, function (input) {
				return input.value;
			});
		}

		function apply() {
			var certs = activeCategory ? activeValues(activeCategory, 'certification') : [];
			var lengths = activeCategory ? activeValues(activeCategory, 'length') : [];
			var sizes = activeCategory ? activeValues(activeCategory, 'size') : [];
			var visibleCount = 0;

			cards.forEach(function (card) {
				var facets = parseFacets(card);
				var visible = true;

				if (activeCategory && facets.category !== activeCategory) visible = false;
				if (visible && certs.length && certs.indexOf(facets.certification) === -1) visible = false;
				if (visible && lengths.length && !intersects(lengths, facets.lengths)) visible = false;
				if (visible && sizes.length && !intersects(sizes, facets.sizes)) visible = false;

				card.hidden = !visible;
				if (visible) visibleCount++;
			});

			if (emptyState) emptyState.hidden = visibleCount !== 0;
		}

		function clearPanel(category) {
			var panel = root.querySelector('[data-clearance-subfilters="' + category + '"]');
			if (!panel) return;

			Array.prototype.forEach.call(panel.querySelectorAll('[data-clearance-filter]'), function (input) {
				input.checked = false;
			});
		}

		function selectCategory(category, updateHash) {
			// Clicking the active category again clears it, back to the full catalog.
			if (activeCategory === category) category = '';

			if (activeCategory && activeCategory !== category) clearPanel(activeCategory);

			activeCategory = category;

			categoryButtons.forEach(function (button) {
				var isActive = button.getAttribute('data-clearance-category') === activeCategory;
				button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
			});

			subfilterPanels.forEach(function (panel) {
				panel.hidden = panel.getAttribute('data-clearance-subfilters') !== activeCategory;
			});

			if (updateHash && window.history && window.history.replaceState) {
				var hash = categoryToHash[activeCategory];
				// replaceState rather than assigning location.hash, which would scroll the page to the anchor
				// and yank the shopper away from the filter row they just clicked.
				window.history.replaceState(null, '', hash ? '#' + hash : window.location.pathname + window.location.search);
			}

			apply();
		}

		function readHash() {
			var hash = window.location.hash.replace('#', '').toLowerCase();
			var category = hashToCategory[hash];
			// Only act on a hash this section owns. An unrelated anchor elsewhere on the page must not
			// silently clear the shopper's current filter.
			if (category) selectCategory(category, false);
		}

		categoryButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				selectCategory(button.getAttribute('data-clearance-category'), true);
			});
		});

		root.addEventListener('change', function (event) {
			if (event.target.matches('[data-clearance-filter]')) apply();
		});

		window.addEventListener('hashchange', readHash);

		readHash();
		apply();
	}

	function init() {
		Array.prototype.forEach.call(document.querySelectorAll('[data-clearance-root]'), setUp);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();